<template>
    <q-card v-if="localModel" :inline="inline" class="card">
        <q-card-title>
            <q-field label="Nazwa" v-if="inEdit">
                <q-input type="text" v-model="localModel.label"></q-input>
            </q-field>
            <q-input type="text" v-model="localModel.label" :readonly="true" v-else></q-input>
        </q-card-title>

        <q-card-media>
            <drop-area @dropped="dropped" v-if="inEdit">
                Upuść obraz
                <image-viewer :src="localModel.thumbUrl" v-if="localModel.thumbUrl"/>
            </drop-area>
            <image-viewer :src="localModel.thumbUrl" v-else-if="localModel.thumbUrl"/>
        </q-card-media>

        <q-card-main>
            <q-field label="Opis" v-if="inEdit">
                <q-input type="textarea" v-model="localModel.description"></q-input>
            </q-field>
            <q-input type="textarea" v-model="localModel.description" v-else :readonly="true"></q-input>
        </q-card-main>

        <q-card-actions class="justify-end actions" v-if="editable">

            <publish-button v-if="editable"
                            :model="localModel"
                            what="activity"
            />

            <q-btn v-if="editable"
                   icon="edit"
                   round
                   size="sm"
                   :to="{name: 'activity-edit', params: {activityTypeId: localModel.activityTypeId}}"/>

            <q-btn v-if="editable"
                   icon="delete"
                   round
                   size="sm"
                   @click="confirmAndDelete"/>

        </q-card-actions>
    </q-card>
</template>

<script>
    import QCardMedia from 'quasar-framework/src/components/card/QCardMedia'
    import QCardTitle from 'quasar-framework/src/components/card/QCardTitle'
    import QCardMain from 'quasar-framework/src/components/card/QCardMain'
    import Upload from './Upload'
    import DropArea from './DropArea'
    import QInput from 'quasar-framework/src/components/input/QInput'
    import ImageViewer from './pole/viewers/ImageViewer'
    import QCardActions from 'quasar-framework/src/components/card/QCardActions'
    import QBtn from 'quasar-framework/src/components/btn/QBtn'
    import PublishButton from './pole/PublishButton'

    export default {
        name: 'ActivityComponent',
        components: {
            PublishButton,
            QBtn, QCardActions, ImageViewer, QInput, DropArea, Upload, QCardMain, QCardTitle, QCardMedia,
        },
        props: ['model', 'editable', 'inEdit', 'inline'],
        data () {
            return {
                localModel: undefined,
            }
        },
        mounted () {
            this.localModel = this.model
        },
        watch: {
            model () {
                this.localModel = this.model
            },
        },
        methods: {
            dropped (e) {
                this.localModel.thumbUrl = JSON.parse(e.dataTransfer.getData('text')).urlPath
            },
            confirmAndDelete () {
                this.$q.dialog({
                    title: `Potwierdź usunięcie aktywności`,
                    message: `Czy na pewno usunąć aktywność ${this.localModel.label}?`,
                    ok: 'Usuń',
                    cancel: 'Anuluj',
                    position: 'top',
                }).then(() => {
                    this.$store.dispatch('remove', {
                        what: 'activity',
                        id: this.localModel.activityTypeId,
                    })
                }).catch(() => {

                })
            },

        },
    }
</script>

<style scoped lang="scss">
    .card {
        border-radius: 20px;
    }
    .actions {
        background-color: gainsboro;
    }
</style>